module.exports = __webpack_public_path__ + "02_long_beige.54a2e77f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_long_beige.png
// module id = xLBY
// module chunks = 0